export default {
  state: {
    isDishItemModalOpenForEditing: false,
    menuDishes: null,
    selectedDishOptions: null
  },
  getters: {
    isDishItemModalOpenForEditing: state => state.isDishItemModalOpenForEditing,
    menuDishes: state => state.menuDishes || [],
    dishById: state => id => {
      if (!state.menuDishes) return;
      return state.menuDishes.find(elm => elm.id === id);
    },
    selectedDishOptions: state => {
      //loggg
    }
  },
  mutations: {
    changeDishItemModalState: (state, payload) => {
      state.isDishItemModalOpenForEditing = payload;
    },
    setMenuDishes: (state, payload) => {
      state.menuDishes = payload;
    }
  },
  actions: {},
  namespaced: true
};
